/* eslint-disable @typescript-eslint/naming-convention */
export const operationTypeData = {
  Celodenní: 'full_day',
  Polodenní: 'half_day',
  Internátní: 'boarding',
};

export const distinctionData = {
  without_distinction: 'Mateřská škola bez rozlišení',
  company_kindergarten: 'Firemní mateřská škola',
  forest_kindergarten: 'Lesní mateřská škola',
  kindergarten_at_an_institutional_education_facility: 'Mateřská škola při zařízení pro ústavní výchovu nebo ochrannou výchovu',
};
